import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';

export default function PackingSlip() {
  const { packingSlipNumber } = useParams();
  const [showIframe, setShowIframe] = useState(false);
  
  const isObjectId = /^[0-9a-fA-F]{24}$/.test(packingSlipNumber);
  const detailUrl = isObjectId 
    ? `https://rlugroup.in/api/packing-slips/${packingSlipNumber}`
    : `https://rlugroup.in/api/packing-slips/details/${packingSlipNumber}`;

  const url = `https://rlugroup.in/pdf/convert?fileName=rlugroup-packing-slip.hbs&id_field=packingSlipNumber&format=A5&margintop=0.2cm&url=${detailUrl}`;
  
  // isMobile from react-device-detect excludes tablets automatically
  const isMobilePhone = isMobile || isTablet;

  const handleDownload = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `packing-slip-${packingSlipNumber}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback to opening in new tab
      window.open(url, '_blank');
    }
  };
  
  useEffect(() => {
    // Delay iframe rendering to ensure PDF service is ready (for desktop and tablets only)
    if (!isMobilePhone) {
      setTimeout(() => setShowIframe(true), 150);
    }
  }, [isMobilePhone]);
  
  if (isMobilePhone) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: '#f3f4f6'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px 30px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="14 2 14 8 20 8" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="12" y1="18" x2="12" y2="12" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="9" y1="15" x2="12" y2="18" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="15" y1="15" x2="12" y2="18" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 style={{ 
            marginBottom: '10px', 
            color: '#374151',
            fontSize: '24px',
            fontWeight: '600'
          }}>
            Packing Slip PDF
          </h2>
          <p style={{ 
            color: '#6B7280', 
            marginBottom: '30px',
            fontSize: '14px',
            lineHeight: '1.5'
          }}>
            For the best experience on mobile devices, please download the PDF to view it.
          </p>
          <button 
            onClick={handleDownload}
            style={{
              display: 'block',
              width: '100%',
              padding: '14px 24px',
              backgroundColor: '#3B82F6',
              color: 'white',
              borderRadius: '8px',
              border: 'none',
              fontWeight: '600',
              fontSize: '16px',
              marginBottom: '12px',
              boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
              transition: 'all 0.2s',
              cursor: 'pointer'
            }}
          >
            Download PDF
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
      {showIframe ? (
        <iframe
          src={url}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block'
          }}
          title="Packing Slip PDF"
        />
      ) : (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          backgroundColor: '#f3f4f6',
          color: '#4B5563',
          fontSize: '18px'
        }}>
          <div className="animate-spin" style={{
            width: '30px',
            height: '30px',
            border: '3px solid #e5e7eb',
            borderTopColor: '#3B82F6',
            borderRadius: '50%',
            marginRight: '15px'
          }}></div>
          Loading PDF...
        </div>
      )}
    </div>
  )
}
